export const color = {
  primary: '#00929d',
  grey: '#a6a6a6',
  lightGrey: '#ebebeb',
  darkGrey: '#51626f',
  white: '#ffffff',
  black: '#000000',
} as const;
